import { render } from "./LocationFormInput.vue?vue&type=template&id=424531a6"
import script from "./LocationFormInput.vue?vue&type=script&lang=ts"
export * from "./LocationFormInput.vue?vue&type=script&lang=ts"
script.render = render

export default script